import * as moment from "moment";
import {
  FILTERS_ACTIONS,
  FILTERS_SAVED,
  FiltersStateInterface,
} from "../actions/filters.actions";

export const INITIAL_FILTERS_STATE: FiltersStateInterface = {
  startDate: moment().hours(0).minute(0).seconds(0).millisecond(0).toDate(),
  endDate: moment().hours(23).minute(59).seconds(59).millisecond(0).toDate(),
  week: null,
  year: moment()
    .hours(0)
    .minute(0)
    .seconds(0)
    .millisecond(0)
    .toDate()
    .getFullYear(),
  sameDay: true,
  edited: null,
  channels: [],
  referentialEntities: [],
  keywords: null,
  idValue: null,
  forceLanguageInter: false,
  broadcastingCountries: [],
  languageId: -1,
  defaultDestination: localStorage.getItem("defaultDestination"),
  field: "All fields",
  filterDestination: "AllDestinations",
  fieldStatus: "All status",
  idType: "ProgramId",
  fromDashboard: false,
  midnightMode: false,
  updatedInTheLastHours: 0,
  showHidden: false,
};

export function filtersReducer(
  state: FiltersStateInterface = INITIAL_FILTERS_STATE,
  action
) {
  switch (action.type) {
    case FILTERS_ACTIONS.SET_DATES:
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;

      state.sameDay = state.startDate.getTime() === state.endDate.getTime();

      state.week = action.payload.week;
      state.year = action.payload.year;
      state.midnightMode = action.payload.midnightMode;

      return { ...state };

    case FILTERS_ACTIONS.SET_FILTERS:
      localStorage.setItem(FILTERS_SAVED, JSON.stringify(action.payload));
      return { ...action.payload };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/filters.reducer.ts